<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full">

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- The @if (true) block lets the router outlet update when the layout changes. -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

</div>
